import React from 'react';
import styles from './Page.module.css';

// SCRUM-450: the one outer frame used by every dashboard page. Page CSS
// modules used to each declare their own .container width/centering/padding
// (600px centered, 860px centered, 1200px centered, no constraint at all…),
// so the same PageHeader landed at a different left edge on every page. This
// component is the only place page-level width/margin/padding is set; a
// page's own CSS module must not redeclare them.
//
// `narrow` gives the content column a 640px max-width for single-column form
// pages (Defaults, event create/edit) — the column still starts at the same
// left edge as every other page, it just doesn't stretch full width.
//
// `wide` drops the 1200px max-width entirely for dense operator pages (ops
// photo grids) — same padding and left anchoring as every other page, it
// just isn't capped on the right.
export default function Page({ narrow, wide, children }) {
  return (
    <div className={`${styles.page} ${wide ? styles.wide : ''}`}>
      {narrow ? <div className={styles.narrow}>{children}</div> : children}
    </div>
  );
}
